module.exports = __webpack_public_path__ + "assets/img/6a64-gy.svg";